import {TreoNavigationService} from "./../../../../@treo/components/navigation/navigation.service";
import {Usuarios} from "../../../models/Usuario/usuarios.model";
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import {Router} from "@angular/router";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {User} from "app/layout/common/user/user.types";
import {UserService} from "app/layout/common/user/user.service";
import {TreoConfigService} from "@treo/services/config";
import {MatDialog} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {SenhaComponent} from "app/modules/admin/dialogs/senha/senha.component";
import {DialogComponent} from "./deposito/dialog/dialog.component";
import {bancaUrl} from "app/core/config/app.config";

declare function Ajustes(): any;

@Component({
	selector: "user",
	templateUrl: "./user.component.html",
	styleUrls: ["./user.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: "user",
})
export class UserComponent implements OnInit, OnDestroy {
	@Input()
	showAvatar: boolean;
	isWebView: boolean = false;
	// Private
	private _unsubscribeAll: Subject<any>;
	private _user: User;
	public usuario: Usuarios = JSON.parse(localStorage.getItem("usuario"));
	urlBanca = bancaUrl;
	/**
	 * Constructor
	 *
	 * @param {ChangeDetectorRef} _changeDetectorRef
	 * @param {Router} _router
	 * @param {UserService} _userService
	 */
	constructor(
		private _treoConfigService: TreoConfigService,
		private _changeDetectorRef: ChangeDetectorRef,
		private _router: Router,
		private _userService: UserService,
		private navigation: TreoNavigationService,
		private dialog: MatDialog,
		private toastr: ToastrService,
	) {
		// Set the private defaults
		this._unsubscribeAll = new Subject();

		// Set the defaults
		this.showAvatar = true;
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Accessors
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Setter and getter for user
	 *
	 * @param value
	 */
	@Input()
	set user(value: User) {
		// Save the user
		this._user = value;

		// Store the user in the service
		this._userService.user = value;
	}

	get user(): User {
		return this._user;
	}

	setTema(tema: string): void {
		this._treoConfigService.config = {theme: tema};
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	baixarApp(): void {
		const fileUrl = "https://pub-d73c0deaa5d24733962b77adc57cad9a.r2.dev/app.apk"; // ou 'assets/instalador.exe' se usar a pasta assets
		const fileName = "app.apk"; // Nome do arquivo ao ser baixado pelo usuário

		const link = document.createElement("a");
		link.href = fileUrl;
		link.setAttribute("download", fileName);

		// Adiciona ao DOM, clica e remove para não deixar resíduos no documento
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
	/**
	 * On init
	 */
	ngOnInit(): void {
		const agent = window.navigator.userAgent;
		if (agent == "Master/Bets") {
			this.isWebView = true;
		} else {
			this.isWebView = false;
		}

		this._userService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe((user: User) => {
			this._user = user;
		});
	}

	numeroParaReal(numero: any) {
		if (numero != undefined) {
			var numero = numero.toFixed(2).split(".");
			numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join(".");
			return numero.join(",");
		}
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	compartilhar() {
		window.open(
			"https://api.whatsapp.com/send?text=Cadastre-se%20pelo%20link%3A%0A" +
				this.urlBanca +
				"sign-in?codigo=" +
				this.usuario.id,
			"_blank",
		);
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Update the user status
	 *
	 * @param status
	 */
	updateUserStatus(status): void {
		// Update the user data
		this.user.status = status;

		// Update the user on the server
		this._userService.update(this.user);
	}

	/**
	 * Sign out
	 */
	ajustes(): void {
		Ajustes();
	}

	signOut(): void {
		localStorage.setItem("Ação", "Saiu");
		this._router.navigate(["/sign-out"]);
	}

	alterarSenha() {
		let dialogRef = this.dialog.open(SenhaComponent, {
			panelClass: "senha",
			disableClose: true,
			hasBackdrop: true,
			autoFocus: false,
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result == "Alterou senha") {
				this.toastr.success("Senha alterada com sucesso, por favor faça login com a nova senha!", "Alterar senha");
				this.signOut();
			} else if (result == "Fechar") {
			} else {
				this.toastr.error(result, "Erro");
			}
		});
	}

	deposito() {
		let dialogRef = this.dialog.open(DialogComponent, {
			panelClass: "mailbox-compose-dialog",
			disableClose: true,
			hasBackdrop: true,
			autoFocus: false,
			data: {
				origem: "Site",
				editando: false,
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result == "Criou") {
				this.toastr.success("Cadastro realizado com sucesso, faça login!", "Cadastro");
			} else if (result == "Fechar") {
			} else {
				this.toastr.error(result, "Erro");
			}
		});
	}
}
